var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('v-progress-circular',{staticClass:"spinner",attrs:{"size":64,"color":"#FF530D","indeterminate":""}}),_c('img',{staticClass:"callout-logo",attrs:{"src":require(`@/assets/images/icon_dark.png`),"alt":"logo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }